/*
* Copyright 2026 Tecnalia, Basque Research & Technology Alliance (BRTA)
*
* Licensed under the Apache License, Version 2.0 (the "License");
* you may not use this file except in compliance with the License.
* You may obtain a copy of the License at
*
*    http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing, software
* distributed under the License is distributed on an "AS IS" BASIS,
* WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
* See the License for the specific language governing permissions and
* limitations under the License.
*
*  SPDX-License-Identifier: Apache-2.0
*/

import { AssetDTO } from "./asset-dto";
import { Offer } from "./catalog-dto";

export class Asset {

    public ID: string;
    public name: string;
    public contentType: string;
    public version: string;
    public baseUrl: string;
    public originalDTO: AssetDTO;
    public distribution: string[];
    public connector?: string;
    public originator?: string;

    constructor(
        ID: string,
        name: string,
        contentType: string,
        version: string,
        baseUrl: string,
        originalDTO: AssetDTO,
        distribution: string[]
    ) {
        this.ID = ID;
        this.name = name;
        this.contentType = contentType;
        this.version = version;
        this.baseUrl = baseUrl;
        this.originalDTO = originalDTO;
        this.distribution = distribution;
    }

    private static getProperty(
        properties: Record<string, unknown>,
        key: string,
        defaultValue = ''
    ): string {
        const v = properties[key];
        if (v === undefined || v === null) {
            return defaultValue;
        }
        if (typeof v === 'string') {
            return v;
        }
        if (typeof v === 'number' || typeof v === 'boolean') {
            return String(v);
        }
        return defaultValue;
    }

    public static createFromDTO(dto: AssetDTO): Asset {
        const props = dto.properties;
        return new Asset(
            dto["@id"],
            Asset.getProperty(props, 'name'),
            Asset.getProperty(props, 'contenttype'),
            Asset.getProperty(props, 'version'),
            dto.dataAddress.baseUrl,
            dto,
            dto.distribution
        );
    }
}

export interface AssetWithOffers extends Asset {
    offers: Offer[];
}